//
//
//
//
//
//

import icon from "../icon";
import X16icplaySvg from "./x16icplay.svg?inline";
export default {
  name: "x16icplayIcon",
  components: {
    X16icplaySvg,
    icon,
  },
};
